/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../src/app/search-panel/components/search-panel.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '../../../../../src/app/search-panel/services/date.service';
import * as import6 from '../../../../../src/app/search-panel/services/search-config.service';
import * as import7 from '../../../../../src/app/search-panel/services/search-api.service';
import * as import8 from '../../../../../src/app/search-panel/services/search-model-util.service';
import * as import9 from '@angular/core/src/linker/view_type';
import * as import10 from '@angular/core/src/change_detection/constants';
import * as import11 from '@angular/core/src/linker/component_factory';
import * as import12 from '../../../../../src/app/shared/services/config.service';
import * as import13 from '../../../../../src/app/shared/services/query-string.service';
import * as import14 from '../../../../../src/app/shared/services/api.service';
import * as import15 from '../../../../../src/app/shared/services/messenger.service';
import * as import16 from '../../../../../src/app/search-panel/components/search-form.component';
import * as import17 from '../../../../../src/app/search-panel/services/search-form.service';
import * as import18 from '../../../../../src/app/search-panel/services/search-form-util.service';
import * as import19 from './search-form.component.ngfactory';
import * as import20 from '@angular/core/src/linker/view_container';
import * as import21 from '../../../../../src/app/search-panel/components/query-selector.component';
import * as import22 from './query-selector.component.ngfactory';
import * as import23 from '../../../../../src/app/shared/components/status.component';
import * as import24 from '../../shared/components/status.component.ngfactory';
import * as import25 from '../../../../../$$_gendir/node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import26 from 'ng2-translate/src/translate.pipe';
import * as import27 from '@angular/core/src/linker/template_ref';
import * as import28 from 'ng2-translate/src/translate.service';
import * as import29 from '@angular/common/src/directives/ng_if';
import * as import30 from '@angular/core/src/change_detection/change_detection_util';
export class Wrapper_SearchPanelComponent {
  /*private*/ _eventHandler:Function;
  context:import0.SearchPanelComponent;
  /*private*/ _changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any) {
    this._changed = false;
    this.context = new import0.SearchPanelComponent(p0,p1,p2,p3);
  }
  ngOnDetach(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  ngDoCheck(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import1.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_SearchPanelComponent_Host:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,([] as any[]),{});
class View_SearchPanelComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import0.SearchPanelComponent>;
  _DateService_0_3:import5.DateService;
  _SearchConfigService_0_4:import6.SearchConfigService;
  _SearchApiService_0_5:import7.SearchApiService;
  _SearchModelUtilService_0_6:import8.SearchModelUtilService;
  _SearchPanelComponent_0_7:Wrapper_SearchPanelComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_SearchPanelComponent_Host0,renderType_SearchPanelComponent_Host,import9.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'obpa-search-panel',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_SearchPanelComponent0(this.viewUtils,this,0,this._el_0);
    this._DateService_0_3 = new import5.DateService();
    this._SearchConfigService_0_4 = new import6.SearchConfigService(this.injectorGet(import12.ConfigService,this.parentIndex),this.injectorGet(import13.QueryStringService,this.parentIndex),this._DateService_0_3);
    this._SearchApiService_0_5 = new import7.SearchApiService(this.injectorGet(import14.ApiService,this.parentIndex),this._SearchConfigService_0_4);
    this._SearchModelUtilService_0_6 = new import8.SearchModelUtilService(this._SearchConfigService_0_4);
    this._SearchPanelComponent_0_7 = new Wrapper_SearchPanelComponent(this._SearchApiService_0_5,this._SearchConfigService_0_4,this.injectorGet(import15.MessengerService,this.parentIndex),this._SearchModelUtilService_0_6);
    this.compView_0.create(this._SearchPanelComponent_0_7.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import11.ComponentRef_<any>(0,this,this._el_0,this._SearchPanelComponent_0_7.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import5.DateService) && (0 === requestNodeIndex))) { return this._DateService_0_3; }
    if (((token === import6.SearchConfigService) && (0 === requestNodeIndex))) { return this._SearchConfigService_0_4; }
    if (((token === import7.SearchApiService) && (0 === requestNodeIndex))) { return this._SearchApiService_0_5; }
    if (((token === import8.SearchModelUtilService) && (0 === requestNodeIndex))) { return this._SearchModelUtilService_0_6; }
    if (((token === import0.SearchPanelComponent) && (0 === requestNodeIndex))) { return this._SearchPanelComponent_0_7.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._SearchPanelComponent_0_7.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const SearchPanelComponentNgFactory:import11.ComponentFactory<import0.SearchPanelComponent> = new import11.ComponentFactory<import0.SearchPanelComponent>('obpa-search-panel',View_SearchPanelComponent_Host0,import0.SearchPanelComponent);
const styles_SearchPanelComponent:any[] = ([] as any[]);
class View_SearchPanelComponent2 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import16.SearchFormComponent>;
  _SearchFormService_0_3:import17.SearchFormService;
  _SearchFormUtilService_0_4:import18.SearchFormUtilService;
  _SearchFormComponent_0_5:import19.Wrapper_SearchFormComponent;
  _text_1:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import20.ViewContainer) {
    super(View_SearchPanelComponent2,renderType_SearchPanelComponent,import9.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'obpa-search-form',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_0 = new import19.View_SearchFormComponent0(this.viewUtils,this,0,this._el_0);
    this._SearchFormService_0_3 = new import17.SearchFormService();
    this._SearchFormUtilService_0_4 = new import18.SearchFormUtilService(this.parentView.parentView.injectorGet(import5.DateService,this.parentView.parentIndex));
    this._SearchFormComponent_0_5 = new import19.Wrapper_SearchFormComponent(this.compView_0.ref,this._SearchFormService_0_3,this._SearchFormUtilService_0_4);
    this._text_1 = this.renderer.createText((null as any),'\n        ',(null as any));
    this.compView_0.create(this._SearchFormComponent_0_5.context);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray2(2,'search',(null as any)),this.eventHandler(this.handleEvent_0));
    this._SearchFormComponent_0_5.subscribe(this,this.eventHandler(this.handleEvent_0),true);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import17.SearchFormService) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._SearchFormService_0_3; }
    if (((token === import18.SearchFormUtilService) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._SearchFormUtilService_0_4; }
    if (((token === import16.SearchFormComponent) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._SearchFormComponent_0_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.parentView.parentView.context.searchFormModel;
    this._SearchFormComponent_0_5.check_searchFormModel(currVal_0_0_0,throwOnChange,false);
    if (this._SearchFormComponent_0_5.ngDoCheck(this,this._el_0,throwOnChange)) { this.compView_0.markAsCheckOnce(); }
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._SearchFormComponent_0_5.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'search')) {
      const pd_sub_0:any = ((<any>this.parentView.parentView.context.performManualSearch($event.value)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_SearchPanelComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  compView_4:import1.AppView<import21.QuerySelectorComponent>;
  _QuerySelectorComponent_4_3:import22.Wrapper_QuerySelectorComponent;
  _text_5:any;
  _text_6:any;
  _text_7:any;
  _el_8:any;
  compView_8:import1.AppView<import23.StatusComponent>;
  _StatusComponent_8_3:import24.Wrapper_StatusComponent;
  _text_9:any;
  _anchor_10:any;
  /*private*/ _vc_10:import20.ViewContainer;
  _TemplateRef_10_5:any;
  _NgIf_10_6:import25.Wrapper_NgIf;
  _text_11:any;
  _text_12:any;
  _pipe_translate_0:import26.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import20.ViewContainer) {
    super(View_SearchPanelComponent1,renderType_SearchPanelComponent,import9.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','well well-sm'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'obpa-query-selector',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_4 = new import22.View_QuerySelectorComponent0(this.viewUtils,this,4,this._el_4);
    this._QuerySelectorComponent_4_3 = new import22.Wrapper_QuerySelectorComponent(this.parentView.injectorGet(import7.SearchApiService,this.parentIndex),this.parentView.injectorGet(import6.SearchConfigService,this.parentIndex));
    this._text_5 = this.renderer.createText((null as any),'\n        ',(null as any));
    this.compView_4.create(this._QuerySelectorComponent_4_3.context);
    this._text_6 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n    \n    ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_0,'obpa-status',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_8 = new import24.View_StatusComponent0(this.viewUtils,this,8,this._el_8);
    this._StatusComponent_8_3 = new import24.Wrapper_StatusComponent();
    this._text_9 = this.renderer.createText((null as any),'\n    \n        ',(null as any));
    this._anchor_10 = this.renderer.createTemplateAnchor((null as any),(null as any));
    this._vc_10 = new import20.ViewContainer(10,8,this,this._anchor_10);
    this._TemplateRef_10_5 = new import27.TemplateRef_(this,10,this._anchor_10);
    this._NgIf_10_6 = new import25.Wrapper_NgIf(this._vc_10.vcRef,this._TemplateRef_10_5);
    this._text_11 = this.renderer.createText((null as any),'\n    \n    ',(null as any));
    this.compView_8.create(this._StatusComponent_8_3.context);
    this._text_12 = this.renderer.createText(this._el_0,'\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_4,new import3.InlineArray2(2,'selectionChange',(null as any)),this.eventHandler(this.handleEvent_4));
    this._QuerySelectorComponent_4_3.subscribe(this,this.eventHandler(this.handleEvent_4),true);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_8,new import3.InlineArray2(2,'retry',(null as any)),this.eventHandler(this.handleEvent_8));
    this._StatusComponent_8_3.subscribe(this,this.eventHandler(this.handleEvent_8),true);
    this._pipe_translate_0 = new import26.TranslatePipe(this.parentView.injectorGet(import28.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._anchor_10,
      this._text_11,
      this._text_12
    ]
    ),[
      disposable_0,
      disposable_1
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import21.QuerySelectorComponent) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 5)))) { return this._QuerySelectorComponent_4_3.context; }
    if (((token === import27.TemplateRef) && (10 === requestNodeIndex))) { return this._TemplateRef_10_5; }
    if (((token === import29.NgIf) && (10 === requestNodeIndex))) { return this._NgIf_10_6.context; }
    if (((token === import23.StatusComponent) && ((8 <= requestNodeIndex) && (requestNodeIndex <= 11)))) { return this._StatusComponent_8_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import30.ValueUnwrapper();
    const currVal_4_0_0:any = this.parentView.context.selectedQuery;
    this._QuerySelectorComponent_4_3.check_selection(currVal_4_0_0,throwOnChange,false);
    this._QuerySelectorComponent_4_3.ngDoCheck(this,this._el_4,throwOnChange);
    const currVal_8_0_0:any = this.parentView.context.status;
    this._StatusComponent_8_3.check_status(currVal_8_0_0,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_8_0_1:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('ERROR: KEYWORDS')),'');
    this._StatusComponent_8_3.check_error(currVal_8_0_1,throwOnChange,valUnwrapper.hasWrappedValue);
    this._StatusComponent_8_3.ngDoCheck(this,this._el_8,throwOnChange);
    const currVal_10_0_0:any = this.parentView.context.searchFormModel;
    this._NgIf_10_6.check_ngIf(currVal_10_0_0,throwOnChange,false);
    this._NgIf_10_6.ngDoCheck(this,this._anchor_10,throwOnChange);
    this._vc_10.detectChangesInNestedViews(throwOnChange);
    this.compView_4.internalDetectChanges(throwOnChange);
    this.compView_8.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this._vc_10.destroyNestedViews();
    this.compView_4.destroy();
    this.compView_8.destroy();
    this._QuerySelectorComponent_4_3.ngOnDestroy();
    this._StatusComponent_8_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  visitProjectableNodesInternal(nodeIndex:number,ngContentIndex:number,cb:any,ctx:any):void {
    if (((nodeIndex == 8) && (ngContentIndex == 0))) {
      cb(this._text_9,ctx);
      cb(this._vc_10.nativeElement,ctx);
      this._vc_10.visitNestedViewRootNodes(cb,ctx);
      cb(this._text_11,ctx);
    }
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 10)) { return new View_SearchPanelComponent2(this.viewUtils,this,10,this._anchor_10,this._vc_10); }
    return (null as any);
  }
  handleEvent_4(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'selectionChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.selectedQuery = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'selectionChange')) {
      const pd_sub_1:any = ((<any>this.parentView.context.onSelectedQueryChange($event)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
  handleEvent_8(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'retry')) {
      const pd_sub_0:any = ((<any>this.parentView.context.onRetry()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
var renderType_SearchPanelComponent:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,styles_SearchPanelComponent,{});
export class View_SearchPanelComponent0 extends import1.AppView<import0.SearchPanelComponent> {
  _anchor_0:any;
  /*private*/ _vc_0:import20.ViewContainer;
  _TemplateRef_0_5:any;
  _NgIf_0_6:import25.Wrapper_NgIf;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_SearchPanelComponent0,renderType_SearchPanelComponent,import9.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._anchor_0 = this.renderer.createTemplateAnchor(parentRenderNode,(null as any));
    this._vc_0 = new import20.ViewContainer(0,(null as any),this,this._anchor_0);
    this._TemplateRef_0_5 = new import27.TemplateRef_(this,0,this._anchor_0);
    this._NgIf_0_6 = new import25.Wrapper_NgIf(this._vc_0.vcRef,this._TemplateRef_0_5);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [this._anchor_0]),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import27.TemplateRef) && (0 === requestNodeIndex))) { return this._TemplateRef_0_5; }
    if (((token === import29.NgIf) && (0 === requestNodeIndex))) { return this._NgIf_0_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:boolean = !this.context.isHidden;
    this._NgIf_0_6.check_ngIf(currVal_0_0_0,throwOnChange,false);
    this._NgIf_0_6.ngDoCheck(this,this._anchor_0,throwOnChange);
    this._vc_0.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_0.destroyNestedViews();
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 0)) { return new View_SearchPanelComponent1(this.viewUtils,this,0,this._anchor_0,this._vc_0); }
    return (null as any);
  }
}


// WEBPACK FOOTER //
// ./$$_gendir/src/app/search-panel/components/search-panel.component.ngfactory.ts